// imports
import Handlebars from 'handlebars';
import {loadShoppingCartItem} from '../../views/widgets/shoppingCartItem/js/loadWg';

export function updateCart(cartSummary) {
	let itemsSummary = cartSummary.itemsSummary;
	let $miniCart = $(document).find('[data-wg="MiniCart"]');
	let $checkoutMiniCart = $(document).find('[data-wg="CheckoutMiniCart"]');
	let $cartPage = $(document).find('[data-pg="ShoppingCartPage"]');
	let cartPage = '.shoppingCartPage-';

	let donationsCheck = false;

	// clear all items
	$miniCart.find('.miniCart-lineItems').empty();
	$checkoutMiniCart.find('.checkoutMiniCart-lineItems').empty();
	$cartPage.find('.line-items').empty();

	// register partials
	let hbsPartials = initHbsPartials();

  // for MC Personalization

  let Products = [];

	// loop through items
	for (let i = 0; i < itemsSummary.length; i++) {
		let itemData = itemsSummary[i];
		$miniCart.find('.miniCart-lineItems').append(hbsPartials.miniCartItemTemplate(itemData));
		$checkoutMiniCart.find('.checkoutMiniCart-lineItems').append(hbsPartials.checkoutMiniCartItemTemplate(itemData));

		$cartPage.find('.line-items').append(`
            <div class="shoppingCartPage-cartItem">
                ${hbsPartials.shoppingCartItemTemplate(itemData)}
            </div>
		`);

		if (itemData.isDonation) donationsCheck = true;

    // update MC Personalization Cart

    let product = {

      _id: itemData.id,

      price: parseFloat(itemData.price.replace('$', '')),

      quantity: parseInt(itemData.quantity),

    };

    Products.push(product);
	}

  // send MC Personalization Event

  if (window.Evergage) {
    window.Evergage.sendEvent({itemAction: window.Evergage.ItemAction.ViewCart, cart: {complete: {Product: Products}}});
  }

	// show/hide donations widget if no/donation item is found
	if (!donationsCheck) {
		$(document).find('.shoppingCartPage-donations').fadeIn('fast');
	} else {
		$(document).find('.shoppingCartPage-donations').fadeOut('fast');
		$(document).find('.shoppingCartPage-donations .donation')
			.find('.success-messages, .error-messages')
			.html('')
			.removeClass('is-active');
	}

	// update minicart title and totals
	$miniCart.find('.miniCart-title').text(`Cart (${itemsSummary.length})`);
	$miniCart.find('.miniCart-subtotalPrice').html(cartSummary.total);

	// update sidebar and siteheader count
	$('.sidebar-cartCount').text(itemsSummary.length);
	$('.siteHeader-cartCount').text(itemsSummary.length);

	// update cart page totals
	if ($cartPage.length > 0) {
		$(`${cartPage}cartDetails`).find('.subtotal-value').text(cartSummary.subtotal);
		$(`${cartPage}cartDetails`).find('.discounttotal-value').text('-' + cartSummary.discountTotal);
		$(`${cartPage}cartDetails`).find('.taxtotal-value').text(cartSummary.totalTaxes);
		$(`${cartPage}cartTotal`).find('.total-value').text(cartSummary.total);
		$(`${cartPage}cartDetails`).find('.shipping-value').text(cartSummary.totalShippingHandling);
	}

	// update donations
	if (donationsCheck) {
		$(document).find('.donations-row')
			.find('.donation-value')
			.html(cartSummary.donations);
	} else {
		$(document).find('.donations-row')
			.find('.donation-value')
			.html('$0.00');
	}

	// hide cart count if 0
	if (!cartSummary || itemsSummary.length === 0) {
		$('.miniCart-title').text('Cart');
		$('.siteHeader-cartCount, .sidebar-cartCount').addClass('d-none');
	} else {
		$('.siteHeader-cartCount, .sidebar-cartCount').removeClass('d-none');

		// init scripts (when needed)
		// the widget script has support for multiple instances
		if ($cartPage.length > 0) {
			loadShoppingCartItem($cartPage[0]).then((wg) => {
				wg ? wg.init() : '';
			}).catch((error) => `${error} An error occurred while loading the ShoppingCartItem widget`);
		}
	}

	// As of now, page refreshes if cart is empty and then views are switched server-side
	// code doen't reach here in that case
}

function initHbsPartials() {
	// Require partial
	let miniCartItem = require('../../views/widgets/miniCart/tmpl/_miniCartItem.hbs');
	let checkoutMiniCartItem = require('../../views/widgets/checkoutMiniCart/tmpl/_checkoutMiniCartItem.hbs');
	let shoppingCartItem = require('../../views/widgets/shoppingCartItem/tmpl/shoppingCartItem.hbs');
	let quantityInput = require('../../views/widgets/quantityInput/tmpl/quantityInput.hbs');

	Handlebars.registerPartial('miniCartItem', miniCartItem);
	Handlebars.registerPartial('checkoutMiniCartItem', checkoutMiniCartItem);
	Handlebars.registerPartial('shoppingCartItem', shoppingCartItem);
	Handlebars.registerPartial('quantityInput', quantityInput);

	let miniCartItemScript = `
        {{> miniCartItem
            wg="miniCart"
        }}
    `;

	let checkoutMiniCartItemScript = `
        {{> checkoutMiniCartItem
            wg="checkoutMiniCart"
        }}
    `;

	// isDisabled is always true for now (no quantity editing api(s) ready)
	let shoppingCartItemScript = `
        {{> shoppingCartItem
            wg="shoppingCartItem"
            ns="ShoppingCartItem"
            isDisabled=true
        }}
    `;

	let miniCartItemPrecompiled = new Function('return ' + Handlebars.precompile(miniCartItemScript))();
	let checkoutMiniCartItemPrecompiled = new Function('return ' + Handlebars.precompile(checkoutMiniCartItemScript))();
	let shoppingCartItemScriptPrecompiled = new Function('return ' + Handlebars.precompile(shoppingCartItemScript))();

	let miniCartItemTemplate = Handlebars.template(miniCartItemPrecompiled);
	let checkoutMiniCartItemTemplate = Handlebars.template(checkoutMiniCartItemPrecompiled);
	let shoppingCartItemTemplate = Handlebars.template(shoppingCartItemScriptPrecompiled);

	return {
		miniCartItemTemplate,
		checkoutMiniCartItemTemplate,
		shoppingCartItemTemplate,
	};
}



// WEBPACK FOOTER //
// ./cart.js